import { TABLE_ROWS } from 'common/constants';
import { OrderDirection, OrderLookup, SortOrder } from 'common/utils/commonTypes';
import {
  AvailablePurchaseOrderRevisionsVariables,
  AvailablePurchaseOrderRevisions_availablePurchaseOrderRevisions,
} from './__generated__/AvailablePurchaseOrderRevisions';
import {
  EntityDocumentFilter,
  EntityDocumentsOrderBy,
} from 'common/types/globalTypes';
import { filterOptionProps } from './Filters';

const orderByMap = new Map<string, OrderLookup>([
  [
    'indexName',
    {
      [OrderDirection.ASC]: ['INDEX_NAME_ASC'],
      [OrderDirection.DESC]: ['INDEX_NAME_DESC'],
    },
  ],
  [
    'indexReferenceNumber',
    {
      [OrderDirection.ASC]: ['INDEX_REFERENCE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['INDEX_REFERENCE_NUMBER_DESC'],
    },
  ],
  [
    'indexTransactionDate',
    {
      [OrderDirection.ASC]: ['INDEX_TRANSACTION_DATE_ASC'],
      [OrderDirection.DESC]: ['INDEX_TRANSACTION_DATE_DESC'],
    },
  ],
  [
    'indexDescription',
    {
      [OrderDirection.ASC]: ['INDEX_DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['INDEX_DESCRIPTION_DESC'],
    },
  ],
  [
    'currency',
    {
      [OrderDirection.ASC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_DESC',
      ],
    },
  ],
  [
    'indexAmount',
    {
      [OrderDirection.ASC]: ['INDEX_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['INDEX_AMOUNT_DESC'],
    },
  ],
  [
    'fileReference',
    {
      [OrderDirection.ASC]: ['FILE_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['FILE_REFERENCE_DESC'],
    },
  ],
]);

export const toOrderByVariable = (
  sort?: SortOrder
): EntityDocumentsOrderBy[] => {
  const orderByArray: EntityDocumentsOrderBy[] = [
    'INDEX_NAME_ASC',
    'PRIMARY_KEY_ASC',
  ];

  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ?? []), 'PRIMARY_KEY_ASC'];
};

export const onHandleSearch = (
  entityDocumentId: string,
  showMore: boolean,
  sortOrderParam: SortOrder | undefined,
  availablePurchaseOrderRevisions:
    | AvailablePurchaseOrderRevisions_availablePurchaseOrderRevisions
    | null
    | undefined,
  filter: EntityDocumentFilter | undefined
) => {
  const { pageInfo } = { ...availablePurchaseOrderRevisions };
  const { endCursor } = { ...pageInfo };
  const variables: AvailablePurchaseOrderRevisionsVariables = {
    entityDocumentId,
    first: TABLE_ROWS,
    orderBy: toOrderByVariable(sortOrderParam),
    after: showMore ? endCursor : undefined,
    filter,
  };
  return {
    queryVariables: variables,
  };
};

export const toFilterVariable = (filterOptions: filterOptionProps) =>
  filterOptions.filterTypes.map((filter) => {
    switch (filter.filterKey) {
      case 'indexReferenceNumber':
      case 'indexDescription':
      case 'indexName':
        return {
          [filter.filterKey]: {
            [filterOptions.startsWith
              ? 'startsWithInsensitive'
              : 'includesInsensitive']: filter.value,
          },
        };
      default:
        return undefined;
    }
  });
